import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        if (!this.accounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.st = new SmartTable();
    }

    move() {
        const accountIds = this.accounts.map(({id}) => id);

        this.isSaving = true;
        this.AccountsResource
            .moveUsersToGroup(this.companyId, this.group.id, this.st.selectedIds[0], accountIds)
            .then(() => this.$state.go('^', {groupId: this.st.selectedIds[0]}))
            .then(() => {
                const key = 'company.user-directories.manage-group.accounts.move.moved';
                const variables = {groupName: this.st.selectedItems[0].groupName};
                this.Alert('success', key, variables);
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/move/move-accounts-to-group.controller.js